import mitt, { Emitter } from "mitt";
import { SignalRPayload } from "../models/ActionModels";

export const EVENT_CONSTANTS = {
    PAYROLL_CONFIGURATION_UPDATE: "payroll:configuration-update",
    CONVERSATION_UPDATE: "conversation:update",
} as const;

type Events = {
    [EVENT_CONSTANTS.PAYROLL_CONFIGURATION_UPDATE]: SignalRPayload | null;
    [EVENT_CONSTANTS.CONVERSATION_UPDATE]: SignalRPayload | null;
    // Add more event types here as needed
}

const baseEmitter: Emitter<Events> = mitt<Events>();

// Create a wrapper that logs all emitted events
export const emitter = {
    ...baseEmitter,
    emit: <Key extends keyof Events>(type: Key, event: Events[Key] = null) => {
        console.log(`Event emitted: ${String(type)}`, event);
        baseEmitter.emit(type, event);
    }
};